import React, { useContext } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import search from "../../assets/search-logo.svg";
import { Link } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useState } from "react";
import { ButtonGroup, Button } from "react-bootstrap";
import { UserContext } from "../../use_context";

// import { workCategoryData, onTagClick } from '../work/header';

function WorksDetailsHeader({ onTagClick }) {
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);

  const handleOffcanvasToggle = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };
  const handleOffcanvasClose = () => {
    setOffcanvasOpen(false); // Set offcanvasOpen state to false when offcanvas is closed
  };

  // const { workCategoryData } = useContext(UserContext);
  return (
    <header className="wide-container  fixed " id="header">
      <Container className="navigation-wrapper" fluid>
        <Navbar
          bg="transparent"
          variant="dark"
          expand="lg"
          className="nav-row first-row "
        >
          <Link to="/homepage">
            <Navbar.Brand href="index.html" className="brand-logo">
              <img
                src={search}
                width="150"
                height="150"
                alt="React Bootstrap logo"
              />
            </Navbar.Brand>
          </Link>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={handleOffcanvasToggle}
          />
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="end"
            className="home-offcanvas-custom"
            show={offcanvasOpen}
            onHide={handleOffcanvasClose}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel">
                {/* <img src={search} className="home-logo" alt="Logo" /> */}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Navbar.Collapse>
                <Nav
                  className="list-inline nav-links menu custom-ml "
                  id="menu"
                >
                  <NavDropdown.Item href="#action3">
                    <Nav.Link
                      className={offcanvasOpen ? "black-text" : "white-text"}
                      href="/Office"
                    >
                      Office
                    </Nav.Link>
                  </NavDropdown.Item>
                  <NavDropdown.Item href="#action3">
                    <Link to="/works" className="text-decoration-none">
                      <Nav.Link
                        className={offcanvasOpen ? "black-text" : "white-text"}
                        href="/Works"
                      >
                        Works
                      </Nav.Link>
                    </Link>
                  </NavDropdown.Item>
                  <NavDropdown.Item href="#action3">
                    <Nav.Link
                      className={offcanvasOpen ? "black-text" : "white-text"}
                      href="/News"
                    >
                      News
                    </Nav.Link>
                  </NavDropdown.Item>
                  <NavDropdown.Item href="#action3">
                    <Nav.Link
                      className={offcanvasOpen ? "black-text" : "white-text"}
                      href="/Contact"
                    >
                      Contact
                    </Nav.Link>
                  </NavDropdown.Item>
                </Nav>
              </Navbar.Collapse>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Navbar>
        {/* <div className="sub-menu-wrapper page-loaded search-align home-offcanvas-custom">
          <ButtonGroup className="sub-menu work-list-inline nav-links">
            {workCategoryData.map((category) => (
              <Button
                key={category.id}
                className="btn-link white-textimportant"
              
                type="button"
                onClick={() => onTagClick(category.id)}
              >
                {category.name}
              </Button>
            ))}
          </ButtonGroup>
        </div> */}
      </Container>
    </header>
  );
}

export default WorksDetailsHeader;
